<template>
  <el-dialog
    center
    width="480px"
    height="240px"
    z-index="99"
    :visible.sync="show">
    <h3 slot="title" class="title">{{$t('other.tip')}}</h3>
    <div class="overlay-wrapper" @click.stop>
      <div class="block">
        <!--文本为：提示-->
        <div class="content">{{$t('tip.tip30')}}</div>
      </div>
    </div>
    <div slot="footer" class="footer">
      <!--文本为：是的，我已确认-->
      <el-button type="info" @click="confirmTip">{{$t('other.yesISure')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name:'photoOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirmTip(){
      this.$emit('comfirm')
    }
  }
};
</script>

<style lang="less" scoped>
.overlay-wrapper {
  //display: flex;
  //align-items: center;
  //justify-content: center;
  height: 88px;
  text-align: left;
  padding: 0 24px;
}
.block {
  //width: 280px;
  /*height: 170px;*/
  //min-height: 170px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  .title {
    line-height: 20px;
    padding: 20px 20px 10px;
    font-size: 15px;
    color: #000;
    font-weight: 600;
    text-align: center;
    margin: 0;
  }
  .content {
    font-size: 14px;
    //padding: 0 15px 20px;
    color: #6E6E6E;
    margin: 0;
    //line-height: 1.5;
    //text-align: center;
    .bold {
      font-weight: 600;
    }
  }
  .footer {
    & /deep/ .van-button--normal {
      width: 100%;
    }
    & /deep/ .van-button {
      border-radius: 0;
    }
    & /deep/ .van-button--info {
      color: var(--theme-color);
      background: #f7f8fa;
      border: none;
      display: block;
    }
  }
}
/deep/ .el-dialog--center {
  margin-top: 40vh !important;
  border-radius: 4px;
}
/deep/ .el-dialog__header {
  height: 72px;
  line-height: 72px;
}
/deep/ .el-dialog__headerbtn {
  top: 0;
}
/deep/ .el-button {
  background-color: #FF8A14;
}
</style>
